import React from "react";
import "../style/Testimonials.css";
import { motion } from "motion/react";

const StarIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.5l2.9 6.2 6.6.7-5 4.6 1.4 6.6L12 17.6 6.1 20.6l1.4-6.6-5-4.6 6.6-.7L12 2.5z" />
    </svg>
);

// Placeholder reviews — swap these for real customer quotes before publishing.
const TESTIMONIALS = [
    {
        name: "Priya Mehta",
        location: "Surat, Gujarat",
        product: "Auto-clean Chimney",
        rating: 5,
        quote: "Zero smoke, zero smell — even with heavy Gujarati cooking every day. Installation was quick and the team explained the auto-clean cycle properly.",
    },
    {
        name: "Rohan Deshmukh",
        location: "Pune, Maharashtra",
        product: "Induction Cooktop",
        rating: 5,
        quote: "Switched our entire kitchen from gas to Bronzer's induction range. Heats up fast, easy to clean, and it looks far more premium than the price suggests.",
    },
    {
        name: "Fatima Sheikh",
        location: "Ahmedabad, Gujarat",
        product: "Chimney + Hob combo",
        rating: 5,
        quote: "We compared three brands before buying. Bronzer's suction power and after-sales support were clearly a level above the rest.",
    },
    {
        name: "Karan Shah",
        location: "Vadodara, Gujarat",
        product: "Auto-clean Chimney",
        rating: 4,
        quote: "Quiet operation is the biggest win for us — barely notice it running. Only wish the remote had a backlit display.",
    },
    {
        name: "Anjali Rao",
        location: "Surat, Gujarat",
        product: "Induction Cooktop",
        rating: 5,
        quote: "Bought this after a friend's recommendation. The finish and build quality feel genuinely high-end in our new kitchen.",
    },
    {
        name: "Vivek Nair",
        location: "Surat, Gujarat",
        product: "Chimney",
        rating: 5,
        quote: "Sata International's team walked us through the whole process, from choosing the right size to fitting it around our existing cabinets.",
    },
];

const Testimonials = () => {
    return (
        <section className="testimonialsBox" id="Testimonials">
            <div className="testimonialsHeader">
                <span className="testimonialsEyebrow">Customer stories</span>
                <h2 className="testimonialsTitle">
                    <span className="titleLight">What</span>
                    <span className="titleBold">They say</span>
                </h2>
                <p className="testimonialsSubtitle">
                    Real kitchens, real feedback, from homes across Gujarat and beyond.
                </p>
            </div>

            <div className="testimonialsGrid">
                {TESTIMONIALS.map((t, i) => (
                    <motion.article
                        key={t.name}
                        className="testimonialCard"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
                    >
                        <span className="testimonialQuoteMark" aria-hidden="true">&ldquo;</span>

                        <div className="testimonialRating" aria-label={`${t.rating} out of 5 stars`}>
                            {Array.from({ length: 5 }, (_, s) => (
                                <span key={s} className={`starWrap${s < t.rating ? " isFilled" : ""}`}>
                                    <StarIcon />
                                </span>
                            ))}
                        </div>

                        <p className="testimonialQuote">{t.quote}</p>

                        <div className="testimonialFooter">
                            <span className="testimonialAvatar" aria-hidden="true">
                                {t.name.split(" ").map((n) => n[0]).join("")}
                            </span>
                            <div className="testimonialWho">
                                <span className="testimonialName">{t.name}</span>
                                <span className="testimonialMeta">{t.location}</span>
                            </div>
                            <span className="testimonialBadge">{t.product}</span>
                        </div>
                    </motion.article>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;